<div class="p-g form-container">
  <form [formGroup]='editforgotForm'>

    <div class="p-g-12 p-0">
      <div class="form-field p-g-12 pl-0 pr-0">
        <div class="form-label">
          <label for="username" id="ariaLabelEmail" translate>Username</label>
        </div>
        <div class="form-control">
          <input formControlName="email" id="email" aria-labelledby="ariaLabelEmail ariaLabelErrorEmail"
            aria-required="true" type="text" #emails pInputText appNoWhiteSpace />
        </div>
        <div class="form-errors" id="ariaLabelErrorEmail"
          *ngIf="editforgotForm.controls.email.errors  && (editforgotForm.controls.email.dirty || editforgotForm.controls.email.touched || submitted)">
          <div [hidden]="!editforgotForm.controls.email.errors.required" translate>
            email_required
          </div>
          <div [hidden]="!editforgotForm.controls.email.errors.pattern" translate>
            email_pattern
          </div>
        </div>
      </div>
    </div>
    <div class="form-buttons p-g-12 p-g-nopad">
      <button class="negative-button mr-0" pButton type="button" icon="fa fa-close" label="Cancel"
        (click)="closeEditForgot($event)"></button>
      <button pButton type="button" label="Submit" icon="fa fa-check" (click)="changePassword($event)"></button>
    </div>
  </form>
</div>

